module.exports = __webpack_public_path__ + "img/6.ddbb1855.jpg";